module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/notifications/notifications.component.css
// module id = ./src/app/views/notifications/notifications.component.css
// module chunks = main